import { Suspense } from "react";

import { MapPanel } from "~/modules/map/components/MapPanel";

import { MapEditorObservationPanelEcologicalFunctionFragment } from "./components/EcologicalFunctionCard/fragments.generated";
import { MapEditorObservationPanelSkeleton } from "./components/MapEditorObservationPanelSkeleton";
import { MapEditorObservationPanelObservationMediaPointFragment } from "./components/ObservationMediaPointCard/fragments.generated";
import {
    MapEditorObservationPanelEcologicalFunctionCreatedFragment,
    MapEditorObservationPanelObservationFragment,
} from "./fragments.generated";
import { MapEditorObservationPanelEditable } from "./MapEditorObservationPanelEditable";
import { MapEditorObservationPanelReadOnly } from "./MapEditorObservationPanelReadOnly";

export interface MapEditObservationPanelProps {
    backHref: string;
    createHrefToEcologicalFunction: (element: MapEditorObservationPanelEcologicalFunctionFragment) => string;
    createHrefToObservationMediaPointCard: (element: MapEditorObservationPanelObservationMediaPointFragment) => string;
    mapEditorFeatureId: string;
    onEcologicalFunctionCreated?: (value: MapEditorObservationPanelEcologicalFunctionCreatedFragment) => void;
    onObservationCloned?: (clonedObservation: MapEditorObservationPanelObservationFragment) => void;
    onObservationDeleted?: () => Promise<void> | void;
    readonly: boolean;
    title: string;
}

export function MapEditorObservationPanel({
    backHref,
    createHrefToEcologicalFunction,
    createHrefToObservationMediaPointCard,
    mapEditorFeatureId,
    onEcologicalFunctionCreated,
    onObservationCloned,
    onObservationDeleted,
    readonly,
    title,
}: MapEditObservationPanelProps) {
    return (
        <MapPanel>
            <Suspense key={mapEditorFeatureId} fallback={<MapEditorObservationPanelSkeleton />}>
                {readonly ? (
                    <MapEditorObservationPanelReadOnly
                        backHref={backHref}
                        createHrefToEcologicalFunction={createHrefToEcologicalFunction}
                        createHrefToObservationMediaPointCard={createHrefToObservationMediaPointCard}
                        mapEditorFeatureId={mapEditorFeatureId}
                        title={title}
                    />
                ) : (
                    <MapEditorObservationPanelEditable
                        backHref={backHref}
                        createHrefToEcologicalFunction={createHrefToEcologicalFunction}
                        createHrefToObservationMediaPointCard={createHrefToObservationMediaPointCard}
                        mapEditorFeatureId={mapEditorFeatureId}
                        onEcologicalFunctionCreated={onEcologicalFunctionCreated}
                        onObservationCloned={onObservationCloned}
                        onObservationDeleted={onObservationDeleted}
                        title={title}
                    />
                )}
            </Suspense>
        </MapPanel>
    );
}
